import { http, notify } from 'utils'
import { checkEmail } from 'utils/errorHelpers'
import { pick, concat } from 'lodash'

// Manager mutation imports.
import { SET_MANAGER, SET_MANAGERS, SET_MANAGERS_COUNTS, SET_MANAGERS_PAGINATION, ADD_MANAGERS, RESET_MANAGERS, RESET_MANAGER } from 'vx/mutations'

// User sub-modules.
import staff from './manager/staff'

const modules = {
  staff
}

// Manager state.
const state = {
  manager: null,
  managers: [],
  managersCounts: {
    all: 0,
    active: 0,
    inactive: 0
  },
  pagination: {}
}

// Manager getters.
const getters = {
  haveManager: (state) => {
    return state.manager !== null
  },

  haveNoMoreManagers: (state) => {
    return state.pagination.current_page >= state.pagination.last_page ||
      state.pagination.total === 0
  }
}

// Manager actions.
const actions = {
  getManager ({ commit }, id) {
    return http.get(`managers/${id}`)
      .then((response) => {
        commit(SET_MANAGER, response.data)

        return response
      })
  },

  getManagerCounts ({ commit }, params) {
    return http.get('manager-counts', { params })
      .then((response) => {
        commit(SET_MANAGERS_COUNTS, response.data)

        return response
      })
  },

  getManagers ({ commit }, params = {}) {
    return http.get('managers', { params })
      .then((response) => {
        commit(SET_MANAGERS, response.data.data)
        commit(SET_MANAGERS_PAGINATION, response.data.meta)

        return response
      })
  },

  getManagersForNextPage ({ commit, state, getters }, params = {}) {
    if (getters.haveNoMoreManagers) {
      return Promise.reject(new Error('There are no more managers to load.'))
    }

    params.page = state.pagination.current_page + 1

    return http.get(`managers`, { params })
      .then((response) => {
        commit(ADD_MANAGERS, response.data.data)
        commit(SET_MANAGERS_PAGINATION, response.data.meta)

        return response
      })
  },

  addManagers ({ commit }, managers) {
    commit(ADD_MANAGERS, managers)
  },

  resetManager ({ commit }) {
    commit(RESET_MANAGER)
  },

  resetManagers ({ commit }) {
    commit(RESET_MANAGERS)
  },

  storeManager ({ commit }, payload) {
    return http.post(`managers`, payload)
      .catch(error => {
        if (checkEmail(error)) {
          notify.error('That email has already been taken.')
        } else {
          notify.error('Something went wrong. Please check your input and try again.')
        }
      })
  }
}

// Manager state mutations.
const mutations = {
  [SET_MANAGER] (state, manager) {
    state.manager = manager
  },

  [SET_MANAGERS] (state, managers) {
    state.managers = managers
  },

  [SET_MANAGERS_COUNTS] (state, managersCounts) {
    state.managersCounts = managersCounts
  },

  [SET_MANAGERS_PAGINATION] (state, pagination) {
    state.pagination = pick(pagination, ['current_page', 'per_page', 'total', 'last_page'])
  },

  [ADD_MANAGERS] (state, managers) {
    state.managers = concat(state.managers, managers)
  },

  [RESET_MANAGERS] (state) {
    state.managers = []
    state.pagination = {}
  },

  [RESET_MANAGER] (state) {
    state.manager = null
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, modules, state, getters, actions, mutations
}
